// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"100e4581","211":"4c6fb06c","638":"64fcfe22"}[chunkId] + ".chunk.js";
};